/**
 * The resource-slice routing claim table (ADR-0031): each slice's type names,
 * file extensions and processor slot. Routing derives from these
 * claims, never from a type-name substring. THREE-free and React-free, so a
 * linter entry point can read it. Each slice's `index.ts` registers itself.
 */
import { fileExtension } from './fileExtension';
const byTypeName = new Map();
const byExtension = new Map();
const all = [];
export function registerResourceSlice(registration) {
    for (const typeName of registration.typeNames) {
        const existing = byTypeName.get(typeName);
        if (existing && existing.slice !== registration.slice) {
            throw new Error(`Resource type "${typeName}" is already claimed by slice "${existing.slice}" ` +
                `(re-claimed by "${registration.slice}")`);
        }
        byTypeName.set(typeName, registration);
    }
    for (const extension of registration.extensions ?? []) {
        const existing = byExtension.get(extension);
        if (existing && existing.slice !== registration.slice) {
            throw new Error(`Extension "${extension}" is already claimed by slice "${existing.slice}" ` +
                `(re-claimed by "${registration.slice}")`);
        }
        byExtension.set(extension, registration);
    }
    all.push(registration);
}
/**
 * Claims a family slice (the shapes, the primitive meshes) served as plain data by
 * the generic `resource` bus slot. No `extensions`: every Godot-text slice shares
 * `.tres`, and a duplicate extension claim throws, so these route by `type=` name.
 */
export function registerGenericResourceSlice(slice, typeNames, { declaresNoProperties = false } = {}) {
    registerResourceSlice({ slice, kind: 'godot-text', typeNames, busType: 'resource', declaresNoProperties });
}
export const resourceSliceRegistry = {
    byTypeName: (typeName) => byTypeName.get(typeName) ?? null,
    byExtension: (extension) => byExtension.get(extension) ?? null,
    /** The slot the slice claiming the path's extension loads it on, or null when no slice claims it. */
    busTypeOfPath: (path) => {
        const extension = fileExtension(path);
        return (extension !== null && byExtension.get(extension)?.busType) || null;
    },
    /** Whether the slice claiming `busType` marks its values clone-per-consumer. */
    clonesPerConsumer: (busType) => all.some((r) => r.busType === busType && r.clonePerConsumer === true),
    all: () => all,
};
//# sourceMappingURL=sliceRegistration.js.map